// import { useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";

// const LanguageSync = () => {
//   const { i18n } = useTranslation();
//   const lang = i18n.language || "en";
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const pathSegments = location.pathname.split("/");
//     const currentLang = pathSegments[1];

//     if (["en", "de", "ru", "uk", "fr"].includes(currentLang)) {
//       if (currentLang !== lang) {
//         const newPath = `/${lang}${location.pathname.slice(
//           currentLang.length + 1
//         )}`;
//         navigate(newPath + location.search, { replace: true });
//       }
//     } else {
//       // если язык в URL не указан — редиректим с языком
//       navigate(`/${lang}${location.pathname}`, { replace: true });
//     }
//   }, [lang, location.pathname, location.search, navigate]);

//   return null;
// };

// export default LanguageSync;



// import { useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import * as Sentry from "@sentry/react";

// const SUPPORTED = ["en", "de", "ru", "uk", "fr"];

// function clean(path) {
//   let p = (path || "/").replace(/\/{2,}/g, "/");
//   if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
//   return p;
// }
// function getUrlLang(pathname) {
//   const seg = clean(pathname).split("/")[1];
//   return SUPPORTED.includes(seg) ? seg : null;
// }
// function withLangPrefix(lang, restPath) {
//   const rest = clean(restPath).replace(/^\/(en|de|ru|uk|fr)(?=\/|$)/, "");
//   const combined = `/${lang}/${rest.replace(/^\//, "")}`;
//   return clean(combined);
// }

// export default function LanguageSync() {
//   const { i18n } = useTranslation();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const safeNavigate = (to, reason) => {
//     const from =
//       window.location.pathname + window.location.search + window.location.hash;
//     if (clean(window.location.pathname) === clean(to)) return;

//     Sentry.addBreadcrumb({
//       category: "navigation",
//       message: `${from} → ${to}`,
//       level: "info",
//       data: { reason },
//     });

//     try {
//       navigate(to, { replace: true });
//     } catch (e) {
//       Sentry.captureException(e, (scope) => {
//         scope.setTag("nav_from", from);
//         scope.setTag("nav_to", to);
//         scope.setTag("nav_reason", reason);
//         scope.setContext("lang-sync", {
//           i18nLang: i18n.language,
//           pathname: window.location.pathname,
//         });
//       });
//       throw e;
//     }
//   };

//   // 1) На входе: если в URL уже есть язык — синхронизируем i18n; если нет — добавим префикс
//   useEffect(() => {
//     const path = clean(location.pathname);
//     const urlLang = getUrlLang(path);

//     if (urlLang) {
//       if (i18n.language !== urlLang) {
//         try {
//           i18n.changeLanguage(urlLang);
//           document.documentElement.lang = urlLang;
//         } catch (e) {
//           Sentry.captureException(e, (scope) => {
//             scope.setTag("phase", "init-changeLanguage");
//             scope.setContext("lang-sync", {
//               urlLang,
//               i18nLang: i18n.language,
//               path,
//             });
//           });
//         }
//       }
//       return;
//     }

//     const target =
//       withLangPrefix(i18n.language || "en", path) +
//       location.search +
//       location.hash;

//     if (target !== path + location.search + location.hash) {
//       safeNavigate(target, "initial-sync");
//     }
//   }, [location.pathname, location.search, location.hash, i18n]);

//   // 2) При смене языка в UI — сразу правим URL (replace) и <html lang>
//   useEffect(() => {
//     const onLang = (newLang) => {
//       try {
//         const path = clean(window.location.pathname);
//         const target =
//           withLangPrefix(newLang, path) +
//           window.location.search +
//           window.location.hash;

//         document.documentElement.lang = newLang;
//         if (target !== path + window.location.search + window.location.hash) {
//           safeNavigate(target, "language-changed");
//         }
//       } catch (e) {
//         Sentry.captureException(e, (scope) => {
//           scope.setTag("phase", "handler-languageChanged");
//           scope.setContext("lang-sync", {
//             newLang,
//             pathname: window.location.pathname,
//           });
//         });
//       }
//     };

//     i18n.on("languageChanged", onLang);
//     return () => i18n.off("languageChanged", onLang);
//   }, [i18n]);

//   return null;
// }


import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";

const SUPPORTED = ["en", "de", "ru", "uk", "fr"];

function clean(path) {
  let p = (path || "/").replace(/\/{2,}/g, "/");
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p;
}
function getUrlLang(pathname) {
  const seg = clean(pathname).split("/")[1];
  return SUPPORTED.includes(seg) ? seg : null;
}
function withLangPrefix(lang, restPath) {
  const rest = clean(restPath).replace(/^\/(en|de|ru|uk|fr)(?=\/|$)/, "");
  const combined = `/${lang}/${rest.replace(/^\//, "")}`;
  return clean(combined);
}

export default function LanguageSync() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const safeNavigate = (to, reason) => {
    const from =
      window.location.pathname + window.location.search + window.location.hash;
    if (
      clean(
        window.location.pathname + window.location.search + window.location.hash
      ) === clean(to)
    )
      return;

    Sentry.addBreadcrumb({
      category: "navigation",
      message: `${from} → ${to}`,
      level: "info",
      data: { reason },
    });

    try {
      navigate(to, { replace: true });
    } catch (e) {
      Sentry.captureException(e, (scope) => {
        scope.setTag("nav_from", from);
        scope.setTag("nav_to", to);
        scope.setTag("nav_reason", reason);
        scope.setContext("lang-sync", {
          i18nLang: i18n.language,
          pathname: window.location.pathname,
        });
      });
      throw e;
    }
  };

  // 1) На входе: синхронизируем i18n с URL или добавляем префикс
  useEffect(() => {
    const path = clean(location.pathname);
    const urlLang = getUrlLang(path);

    if (urlLang) {
      if (i18n.language !== urlLang) {
        try {
          i18n.changeLanguage(urlLang);
          if (typeof document !== "undefined") {
            document.documentElement.lang = urlLang; // ✅ guard
          }
        } catch (e) {
          Sentry.captureException(e, (scope) => {
            scope.setTag("phase", "init-changeLanguage");
            scope.setContext("lang-sync", {
              urlLang,
              i18nLang: i18n.language,
              path,
            });
          });
        }
      }
      return;
    }

    const target =
      withLangPrefix(i18n.language || "en", path) +
      location.search +
      location.hash;

    if (target !== path + location.search + location.hash) {
      safeNavigate(target, "initial-sync");
    }
  }, [location.pathname, location.search, location.hash, i18n]);

  // 2) При смене языка в UI — мгновенно правим URL и <html lang>
  useEffect(() => {
    const onLang = (newLang) => {
      try {
        const path = clean(window.location.pathname);
        const target =
          withLangPrefix(newLang, path) +
          window.location.search +
          window.location.hash;

        if (typeof document !== "undefined") {
          document.documentElement.lang = newLang; // ✅ guard
        }
        if (target !== path + window.location.search + window.location.hash) {
          safeNavigate(target, "language-changed");
        }
      } catch (e) {
        Sentry.captureException(e, (scope) => {
          scope.setTag("phase", "handler-languageChanged");
          scope.setContext("lang-sync", {
            newLang,
            pathname: window.location.pathname,
          });
        });
      }
    };

    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, [i18n]);

  return null;
}
